class AdpChartLegendController {
  constructor() {
    this.name = 'adpChartLegend';
  }
}

export default AdpChartLegendController;



// WEBPACK FOOTER //
// ./src/app/components/adpChartLegend/adpChartLegend.controller.js